import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'slider-images',
  templateUrl: './slider-images.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./slider-images.component.scss'],
})
export class SliderImages {
  @Input() images: string[] = [];
}
